import Api from '~/api';
import { SUCCESS, ERROR } from '../middleware/promise';

export const EVENT_SHOW = 'EVENT_SHOW';
export const EVENT_SHOW_SUCCESS = `${EVENT_SHOW}_${SUCCESS}`;
export const EVENT_SHOW_ERROR = `${EVENT_SHOW}_${ERROR}`;

export const eventShow = (params) => ({
  type: EVENT_SHOW,
  payload: Api.eventShow(params),
});

export const EVENTS_SHOW = 'EVENTS_SHOW';
export const EVENTS_SHOW_SUCCESS = `${EVENTS_SHOW}_${SUCCESS}`;
export const EVENTS_SHOW_ERROR = `${EVENTS_SHOW}_${ERROR}`;

export const eventsShow = () => ({
  type: EVENTS_SHOW,
  payload: Api.eventsShow(),
});
